"use client";

import { useState } from "react";

const LEVELS = ["Guessing", "Unsure", "Fairly sure", "Certain"];

// The Deep read asks how sure you are before it shows the answer. Letting a
// visitor tap it here says more than the sentence describing it.
export default function ConfidenceDemo() {
  const [picked, setPicked] = useState<number | null>(null);
  return (
    <div role="radiogroup" aria-label="How sure are you">
      <p className="mb-4 font-body text-base font-semibold text-paper">How sure are you?</p>
      <div className="flex flex-wrap gap-3">
        {LEVELS.map((label, i) => (
          <button
            key={label}
            type="button"
            role="radio"
            aria-checked={picked === i}
            onClick={() => setPicked(i)}
            className={`min-h-12 rounded-full px-5 py-3 font-body text-base ${
              picked === i
                ? "bg-blue text-blue-deep"
                : "bg-paper/10 text-paper hover:-translate-y-0.5 hover:bg-paper/20"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <p
        className={`mt-5 min-h-14 font-body text-base leading-relaxed text-muted-dark transition-opacity duration-500 ${
          picked === null ? "opacity-0" : "opacity-100"
        }`}
      >
        {picked === null ? "" : "Logged. The answer is shown after this, so the gap between sure and right is visible."}
      </p>
    </div>
  );
}
